module.exports = __webpack_public_path__ + "img/cliRemover1.c4497c0d.jpg";